import React, {useState, useEffect} from 'react';

//https://www.youtube.com/watch?v=ztvNwFV0Ai0
const styles = {
  transition : 'all 0.5s ease-in-out'
};

const TwistSticker = ( {isShown} ) => {
    const [opacity, setOpacity] = useState(0);
    const [scale, setScale] = useState(0);

    useEffect( () => {
        setScale(isShown ? 1 : 0);
        setOpacity(isShown ? 1 : 0);
        //console.log('__000 : ' + isShown);
    }, [isShown]);

    return (
        <div className='twistTextContainer'
            style={{...styles, opacity : [opacity], transform: 'scale(' + [scale] + ')'}}
        >
        </div>
    );
};

export default TwistSticker;